import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { m11, m9 } from "../../constant/Index";
import { logout } from "../../store/reducers/AuthReducers";
import { clearMessage, setSuccess } from "../../store/reducers/globalReducers";
import {
	useGetProfileQuery,
	useUserChangeAvatarMutation,
} from "../../store/services/AuthServices";
import { useGetDriverProfileQuery } from "../../store/services/EditDrivingService";
import { useSiteSettingUrlQuery } from "../../store/services/SiteSettingServices";
import { ToastMessage } from "../../utils/ShowToastMessage";
import Spinner from "./../../utils/Loader";

const ProfileTab = () => {
	let dispatch = useDispatch();
	let { success } = useSelector((state) => state.globalReducer);
	const { data: ImageUrl, isFetching: ImageLoad } = useSiteSettingUrlQuery();
	// const { driverProfile } = useSelector((state) => state.AuthReducer);
	let { data, isFetching } = useGetProfileQuery();
	let { data: driverProfileData, isLoading: load } = useGetDriverProfileQuery();
	let driverProfile = driverProfileData?.response?.data;
	let user = data?.response?.data;
	console.log(user);

	const [Avatar, response] = useUserChangeAvatarMutation();
	let navigate = useNavigate();
	let location = useLocation();
	const HandleCheck = () => {
		if (driverProfile === null) {
			navigate("/completeyourprofile");
		} else {
			navigate("/driver-profile");
		}
	};
	const [newFile, setNewFile] = useState("");
	const [fileupload, setFileupload] = useState(user?.image);

	const [uploadLoading, setUploadLoading] = useState(false);

	const handleImageUpload = (e) => {
		e.preventDefault();
		if (e.target.files[0].size / 1000000 <= 5) {
			const reader = new FileReader();
			const file = e.target.files[0];
			reader.onloadend = () => {
				setNewFile(file);
				setFileupload(reader.result);
				let FormDatas = new FormData();
				FormDatas.append("avatar", file);
				Avatar(FormDatas);
			};
			reader.readAsDataURL(file);
			setUploadLoading(true);
		} else {
			ToastMessage("file size is greater than 5 mb");
		}
	};

	useEffect(() => {
		if (response.isSuccess) {
			ToastMessage(response?.data?.message);
		}
	}, [response.isSuccess]);

	const HandleLogout = () => {
		dispatch(logout());
		navigate("/");
	};

	return (
		<>
			{!isFetching ? (
				<>
					<div className="ProfileTab">
						<div className="image_div">
							{uploadLoading ? (
								<img src={fileupload} className="img-fluid image_set" alt="" />
							) : (
								<img
									src={
										user?.image === null ? m9 : ImageUrl?.uploads + user?.image
									}
									className="img-fluid image_set"
									alt=""
								/>
							)}
							<div class="change_profile f-mon-reg">
								<label for="fileUpload">
									<div className="bg-img-upload-camera">
										{/* <p class="hvr_p">
                                Change Image
                            </p> */}
									</div>
								</label>

								<input
									hidden
									id="fileUpload"
									type="file"
									accept="image/*"
									onChange={handleImageUpload}
									multiple="false"
								/>
							</div>
						</div>
						<h4 className="name_person mb-4">{`${user?.first_name}${user?.last_name}`}</h4>
						<div
							onClick={() => {
								navigate("/account");
							}}
							className="flx_dividr "
						>
							<p
								className={
									location.pathname === "/account" ? null : "no_active"
								}
							>
								Account
							</p>{" "}
							<img className="mt-1" height={15} width={15} src={m11} />
						</div>
						<div className="brdr-btm-drk"></div>
						<div
							// onClick={() => {
							// 	navigate("/driver-profile");
							// }}
							onClick={HandleCheck}
							className="flx_dividr "
						>
							<p
								className={
									location.pathname === "/driver-profile" ? null : "no_active"
								}
							>
								Driver's Profile
							</p>{" "}
							<img className="mt-1" height={15} width={15} src={m11} />
						</div>
						<div className="brdr-btm-drk"></div>
						<div
							onClick={() => {
								navigate("/my-interest");
							}}
							className="flx_dividr "
						>
							<p
								className={
									location.pathname === "/my-interest" ? null : "no_active"
								}
							>
								My Interest
							</p>{" "}
							<img className="mt-1" height={15} width={15} src={m11} />
						</div>
						<div className="brdr-btm-drk"></div>
						<div
							onClick={() => {
								navigate("/loan-application");
							}}
							className="flx_dividr "
						>
							<p
								className={
									location.pathname === "/loan-application" ? null : "no_active"
								}
							>
								Loan Application status
							</p>{" "}
							<img className="mt-1" height={15} width={15} src={m11} />
						</div>
						<div className="brdr-btm-drk"></div>
						<div className="flx_dividr ">
							<p onClick={HandleLogout}>Logout</p>{" "}
							<img className="mt-1" height={15} width={15} src={m11} />
						</div>
					</div>
				</>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default ProfileTab;
